<template lang="pug">
    .slide.zFadeInRight(ref="slide", v-show="isShow", :style="{ width: width }")
        .hzSlideCover(v-if="isShowCover")
        .slideHd
            i.iconHide(@click="hide") &gt;
            slot(name="head")
                p(v-html="title")
        .slideBd(ref="slideBody", tabindex="-1", @keyup.esc="hide")
            slot {{content}}
</template>


<script>
    export default {
        name: 'hz-slide',
        props: {
            title: String,
            content: String,
            width: { type: String, default: '800px' },
            value: { type: Boolean, default: false },
            isShowCover: { type: Boolean, default: false }
        },
        data() {
            return {
                isShow: this.value || false
            }
        },
        watch: {
            value: {
                handler: function(val) {
                    this.isShow = val;
                    if(val) {
                        setTimeout(e => {
                            this.$refs.slideBody.focus();
                        }, 300)
                    }else {
                        this.$emit('hideCb');
                    }
                }
            }
        },
        mounted() {
            $(this.$refs.slide).appendTo(document.body);
        },
        beforeDestroy() {
            this.$refs.slide && $(this.$refs.slide).remove();
        },
        methods: {
            hide() {
                this.$emit('input', false);
            }
        }
    }
</script>


<style lang="stylus" scoped>
    :host
        display block
    .hzSlideCover
        position fixed
        left 0
        top 0
        width 100%
        height 100%
        z-index 0
    .slide
        position fixed
        top 0
        bottom 0
        right 0
        overflow hidden
        background #fff
        box-shadow -3px 0 11px rgba(0,0,0,.2)
        z-index 15
        transition all .3s ease-in-out
        box-sizing border-box
        font-size 12px
    .slideHd
        background #f5f6fa
        padding-right 15px
        height: 50px
        line-height 50px
        display flex
        overflow hidden
        .iconHide
            flex 0 0 50px
            height 36px
            line-height 45px
            text-align center
            display inline-block
            transform scale(1, 1.8)
            color #666
            cursor pointer
            &:hover
                background #f0f0f0
        p
            flex 1
            padding-left 5px
    .slideBd
        position absolute
        top: 50px
        left: 0
        right: 0
        bottom: 0
        overflow-y auto
        &:focus
            border 0
            outline none
</style>



// WEBPACK FOOTER //
// src/slide.vue